import styled from "styled-components";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { SPACING } from "../../constants/design/spacing";

export const Page = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.three}px;
  background:
    radial-gradient(circle at 50% 0%, ${COLORS.highlight.six}, transparent 34%),
    ${BACKGROUND_COLORS.one};
`;

export const Panel = styled.section`
  width: min(440px, 100%);
  display: flex;
  flex-direction: column;
  gap: ${SPACING.three}px;
  padding: ${SPACING.four}px;
  border: 1px solid ${BORDER_COLORS.one};
  border-radius: 8px;
  background: ${LAYER_COLORS.one};
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.32);
`;

export const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.two}px;
`;

export const AccessIconFrame = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: ${LAYER_COLORS.two};
  color: ${COLORS.highlight.one};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Title = styled.h1`
  ${FONT_CSS.header.five}
  margin: 0;
  color: ${TEXT_COLORS.one};
`;

export const Subtitle = styled.p`
  ${FONT_CSS.body.five}
  margin: 0;
  color: ${TEXT_COLORS.three};
`;

export const Copy = styled.p`
  ${FONT_CSS.body.four}
  margin: 0;
  color: ${TEXT_COLORS.two};
  line-height: 1.5;
`;

export const StatusCard = styled.div<{ variant?: "error" | "neutral" }>`
  ${FONT_CSS.body.five}
  padding: ${SPACING.two}px;
  border-radius: 6px;
  color: ${({ variant }) =>
    variant === "error" ? COLORS.negative.one : TEXT_COLORS.two};
  background: ${({ variant }) =>
    variant === "error" ? COLORS.negative.six : LAYER_COLORS.two};
  border: 1px solid
    ${({ variant }) =>
      variant === "error" ? COLORS.negative.three : BORDER_COLORS.one};
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.one}px;
`;

export const FieldLabel = styled.span`
  ${FONT_CSS.label.three}
  color: ${TEXT_COLORS.three};
  text-transform: uppercase;
`;

export const Input = styled.input<{ error?: boolean }>`
  ${FONT_CSS.body.two}
  min-height: 48px;
  padding: 0 ${SPACING.two}px;
  background-color: ${LAYER_COLORS.two};
  border: 1px solid
    ${({ error }) => (error ? COLORS.negative.one : BORDER_COLORS.one)};
  border-radius: 6px;
  color: ${TEXT_COLORS.one};
  letter-spacing: 0.08em;

  &:focus,
  &:focus-visible {
    outline: none;
    border-color: ${({ error }) =>
      error ? COLORS.negative.one : COLORS.highlight.one};
    box-shadow: 0 0 0 1px
      ${({ error }) => (error ? COLORS.negative.one : COLORS.highlight.one)};
  }

  &::placeholder {
    color: ${TEXT_COLORS.three};
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.two}px;
`;

export const InlineAddress = styled.span`
  color: ${TEXT_COLORS.one};
  font-family: monospace;
`;
